import { useCallback } from 'react';
import type { UnknownAction } from '@reduxjs/toolkit';
import { useAppDispatch } from '../grid/reduxStore/Store';

export default function useDeferredDispatch() {
  const dispatch = useAppDispatch();
  return useCallback(
    (...actions: UnknownAction[]) => {
      setTimeout(() => actions.forEach((action) => dispatch(action)), 0);
    },
    [dispatch]
  );
}
